module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/map-marker-27e00f9974f72bbda6acc2de79cc99f8.svg";